import App from './App';
import Router from './Router';
import View from './View';
import Utils from './Utils';

class Navigation{
    constructor(){
        var self = this;

        this.options = {
            use_route : false,
            view_selector : "#content",
            dataParser : data => $( '<div>' ).html( data ).find( this.options.view_selector ),
        };

        this.view_cache = {};
        this.current_view;
        this.ajax = false;

        this.supportHistory = !!(window.history && history.pushState);

        if( this.ajax ){
            $( document ).on( 'click', 'a', $.proxy( this.linkHooks, this ) );
            window.onpopstate = $.proxy(this.popState, this);
        }

        this.page_loaded = true;
    }

    options( o ){
        $.extend( this.options, o );
    }

    init(){
        this.setView();
        this.renderView();
    }

    setView( link ){
        if( link === undefined )
            link = window.location;

        if( this.options.use_route ) Router.resolve( link );

        if( this.viewExist( link ) ){
            this.current_view = this.view_cache[ link.href ];
        }else{
            let view_class = ( use_route => {
                if( use_route ){
                    return Router.current_route ? Router.current_route.view : View;
                }else{
                    let view_name = $( this.options.view_selector ).data( 'view' );
                    return view_name ? require( 'views/' + view_name ).default : View;
                }
            } )( this.options.use_route );

            this.current_view = View.create( view_class, this.options.view_selector );
            this.view_cache[ link.href ] = this.current_view;

            View.do( 'init', this.current_view );
        }
    }

    getView( link ){
        return this.view_cache[ link ];
    }

    viewExist( link ){
        return !!this.view_cache[ link ];
    }

    renderView(){
        let RenderPromise = $.Deferred();

        View.do( 'beforeRender', this.current_view, RenderPromise )
        View.do( 'render', this.current_view, RenderPromise );
        RenderPromise.done( _ => View.do( 'afterRender', this.current_view, RenderPromise ) );
    }

    popState( e ){
        this.changePage( window.location.href, function(){
            document.title = e.state.title;
        } );
    }

    pushHistory( link, title ){
        history.pushState( { title : title }, document.title = title, link );
    }

    linkHooks( e ){
        if( this.eventLinkToSitePage( e ) ){
            e.preventDefault();
            this.goTo( e.currentTarget.href );
        }
    }

    eventLinkToSitePage( e ){
        var anchor = e.currentTarget,
            link = anchor.href,
            link_host = anchor.host,
            current_host = window.location.host;

        return !!( link_host === current_host && !e.isDefaultPrevented() && this.supportHistory );
    }

    goTo( link ){
        if(window.location.href !== link)
            this.changePage( link, function( link){
                this.pushHistory( link, this.current_view.getDOM( true ).data( 'title' ) );
                App.$window.scrollTop( 0 );
            } );
    }

    changePage( link, callback ){
        this.page_loaded = false;

        var self = this,
            get_request;

        if( this.viewExist( link ) ){
            get_request = false;
            this.page_loaded = true;
        }else{
            get_request = $.ajax( {
                type : 'GET',
                url : link,
                complete : _ => {
                    this.page_loaded = true;
                }
            } );
        }

        $.when( get_request ).done( data => {
            var $content;
            var progress = 0, initial_progress = 0.1;

            if( data ){
                $content = this.options.dataParser( data );
            }else{
                $content = self.getView( link ).getDOM( true );
            }

            // if( typeof _options.progress == 'function' ){
            //     progress += initial_progress;
            //     _options.progress( progress );
            // }

            View.do( 'kill', this.current_view );
            this.current_view.$el.replaceWith( $content );
            this.setView( Utils.fakeLocation( link ) );

            if(typeof callback === 'function')
                callback.call( self, link );

            var $img = $content.find( 'img' ),
                img_progress_part = ( 1 - initial_progress ) / ( $img.length || 1 );

            this.loadImage( $img, {
                progress( current_img, count ){
                    progress = initial_progress + ( current_img * img_progress_part );

                    // if( typeof _options.progress == 'function' ){
                    //     _options.progress( progress );
                    // }
                },

                callback(){
                    self.current_view.call( 'beforeRender' );
                    $.when( _options.outAnimation.call( self ) ).done( function(){
                        self.current_view.call( 'render' );
                    } );
                }
            } );
        } );
    }

    loadImage( $elements, options ){
        var cpt = 0;

        var _options = $.extend({
            progress : null,
            callback : null,
        }, options)

        if( $elements.length ){
            $elements.each(function(index){
                var el = document.createElement('img');

                el.onerror = el.onload = function(e){
                    el.onerror = el.onload = null;

                    cpt++;
                    if( typeof _options.progress == 'function' )
                        _options.progress( cpt, $elements.length );

                    if(cpt >= $elements.length){
                        if( typeof _options.callback == 'function' )
                            _options.callback();
                    }
                }

                el.src = this.src;
            });
        }else{
            if( typeof _options.progress == 'function' )
                _options.progress( 1, 1 );

            if( typeof _options.callback == 'function' )
                _options.callback();
        }
    }
}

export default new Navigation;



// WEBPACK FOOTER //
// ./resources/assets/js/framework/Navigation.js